import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getFVFromXLInvoices(_, { paginate = '', query = '' } = {}) {
        return axios
            .get(`/jobs/jobs/jobs-xl-invoices${paginate}${query}`)
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                handleApiError(error, 'Pobranie danych FV z XL nie powiodło się.')

                return Promise.reject(error)
            })
    },

    refreshFVFromXLInvoicesForJob(_, { id } = {}) {
        return axios
            .post('/jobs/jobs/refresh-xl-invoices', { id: id })
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
}
